module.exports = __webpack_public_path__ + "img/swap-down.091a770b.svg";